<template>
  <div class="quote">
    <div class="quote-image">
      <ShieldMaskFullRotated />
      <img
        :src="quoteImage ? quoteImage : quoteImgPlaceholder"
        alt=""
      >
    </div>
    <div class="quote-content">
      <h2 class="quote-content-title">
        {{ quoteTitle }}
      </h2>
      <span class="quote-content-function">{{ quoteFunction }}</span>
      <p class="quote-content-text">
        {{ quoteText }}
      </p>
    </div>
  </div>
</template>

<script>
import ShieldMaskFullRotated from '../svg/ShieldMaskFullRotated.vue';
export default {
  name: 'KfQuote',
  components: { ShieldMaskFullRotated },
  props: {
    quoteTitle: {
      type: String,
      default: null,
    },
    quoteFunction: {
      type: String,
      default: null,
    },
    quoteText: {
      type: String,
      default: null,
    },
    quoteImage: {
      type: String,
      default: null,
    },
  },
  data(){
    return{
      quoteImgPlaceholder: require('@/assets/svg/quote-image-placeholder.svg?inline'),
      ShieldMaskFullRotated: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ShieldMaskFullRotated.vue'),
    }
  },
};
</script>

<style lang="postcss">
  .quote {

    @screen md {
      @apply flex gap-6;
    }

    &-image {
      @apply relative overflow-hidden mx-auto;
      top: -55px;
      height: 88px;
      width: 88px;
      clip-path: url(#shape-blob-rotated);

      @screen md {
        @apply mx-0 static;
      }

      img {
        max-width: 100%;
        height: auto;
        display: block;
      }
    }

    &-content {

      @screen md {
        max-width: 400px;
      }

      &-title {
        @apply font-playfair text-primary-bravo text-2xl mb-0 text-center;

        @screen md {
          @apply text-3xl text-left;
        }
      }

      &-function {
        @apply block mb-3 text-sm text-gray-400 text-center;

        @screen md {
          @apply text-left;
        }
      }

      &-text {
        @apply italic text-base mb-0 text-center;

        @screen md {
          @apply text-left;
        }
      }
    }

  }
</style>
